// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//
// Used by `ng build --configuration development` (CI deploy to apidev).
// For localhost API, use `--configuration local` / environment.local.ts.
//
// OnlyOffice: ONLYOFFICE_ENABLED / ONLYOFFICE_URL from .env via
// scripts/syncOnlyOfficeEnv.js → onlyOfficeEnv.ts

import {default as data} from '../../package.json';
import { onlyOfficeEnv } from './onlyOfficeEnv';

const environment =
{
    VERSION: data.version,
    production: false,

 //   apiUrl : 'http://localhost:8000',
    apiUrl : 'https://apidev.cyphersystem.com',
    authUrl : 'https://apidev.cyphersystem.com',
    courtUrl : 'https://court.cyphersystem.com',

    onlyOfficeEnabled: onlyOfficeEnv.enabled,
    onlyOfficeUrl: onlyOfficeEnv.url,

    sentryDsn:
        'https://2c0b7179e62f28ec52f8432e6d07d245@o4512148365377536' +
        '.ingest.us.sentry.io/4512148375732224',
    sentryEnvironment: 'development'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`,
 * `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will
 * have a negative impact on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

export { environment };
